import { Box, Card, Grid } from "@mui/material";
import PropTypes from "prop-types";

import InspectionTimeline from "modules/inspections/components/InspectionTimeline";
import SoftBox from "components/SoftComponents/SoftBox";
import SoftButton from "components/SoftComponents/SoftButton";
import { useNavigate } from "react-router-dom";
import SoftTypography from "components/SoftComponents/SoftTypography";
import { wrapper, deviceViewWrapper, loadingScreen } from "utils/wrapper";
import { useState } from "react";
import InspectionPreviewCard from "modules/inspections/components/InspectionPreviewCard";

import inspectionAPI from "modules/inspections/api";
import { useAuth0 } from "@auth0/auth0-react";
import { useQuery } from "@tanstack/react-query";
import { disableMap } from "utils/map";
import { useSoftUIController } from "hooks/context";
import moment from "moment";

function AllAssignmentsView({ map, user }) {
    disableMap(map);

    const navigate = useNavigate();
    inspectionAPI.loadToken(useAuth0());
    const [controller] = useSoftUIController();
    const { deviceLayout } = controller;

    const [adjustments, setAdjustments] = useState({
        search_by: '',
        sort_by: { value: 'date_desc', label: 'Date (Desc)' },
        filter_by: null,
        startTime: moment().subtract(3, 'year'),
        endTime: moment()
    });
    const [selectedInspection, setSelectedInspection] = useState(null);

    // const onNewInspectionClick = () => {
    //     navigate(`/operations/new-inspection`);
    // }

    const all_inspections = useQuery({
        queryKey: ['getAllInspectionsForUser', user],
        queryFn: async () => {
            return await inspectionAPI.getAllInspectionsForUser(user);
        }
    });

    if (all_inspections.isLoading) {
        return loadingScreen(deviceLayout, false);
    }

    if (all_inspections.error) {
        var error = all_inspections.error;
        return wrapper("An error has occurred: " + error.message, deviceLayout);
    }

    if (!all_inspections.data) {
        return wrapper('Loading...', deviceLayout);
    }

    const inspectionTimeline = (
        <SoftBox sx={{ overflowY: 'hidden', borderRadius: '10px', height: "100%" }}>
            <InspectionTimeline selected_user={all_inspections.data.user} not_found_text={'No active assignments found.'} inspections_data={all_inspections.data.inspections.filter((row) => row.status == "unresolved" || row.status == "review")} {...{ selectedInspection, setSelectedInspection, adjustments, setAdjustments, deviceLayout }} />
        </SoftBox>
    );

    return wrapper(
        (
            <SoftBox>
                {deviceLayout == "mobile" ? (
                    <SoftBox borderRadius="20px" color={"white"} width="100%" height={'calc(100svh - 4.25rem - 8px)'} minHeight={"calc(100svh - 4.25rem - 8px)"}
                        sx={({ palette: { white }, functions: { rgba } }) => ({ backgroundColor: rgba(white.main, 0.6), overflowY: 'hidden' })}
                    >
                        {selectedInspection != null ? (
                            <Box sx={{ height: '100%' }}>
                                <InspectionPreviewCard {...{ selectedInspection, setSelectedInspection, user, deviceLayout }} />
                            </Box>
                        ) : (
                            <>
                                <SoftBox p={1}>
                                    <Card sx={{ overflow: "visible", width: '100%', borderRadius: '16px' }}>
                                        <SoftBox mx={2} mt={1} mb={1}>
                                            <SoftBox display='flex' flexDirection='row' justifyContent='space-between'>
                                                <Grid container>
                                                    <Grid item xxs={8}>
                                                        <SoftBox height="100%" display="flex" flexDirection="column" justifyContent="center">
                                                            <SoftTypography variant="h6" fontWeight="bold">All Assignments</SoftTypography>
                                                            {deviceLayout != 'mobile' && (
                                                                <SoftTypography variant="body3">Across Your Organisation</SoftTypography>
                                                            )}
                                                        </SoftBox>
                                                    </Grid>
                                                </Grid>
                                            </SoftBox>
                                        </SoftBox>
                                    </Card>
                                </SoftBox>
                                {inspectionTimeline}
                            </>
                        )}
                    </SoftBox>

                ) : (
                    <SoftBox borderRadius="20px" color={"white"} width="100%" height={"calc(100svh - 5.5rem - 16px)"}
                        sx={({ palette: { white }, functions: { rgba } }) => ({ backgroundColor: rgba(white.main, 0.6), overflowY: 'hidden' })}
                    >
                        <SoftBox m={1}>
                            <Card sx={{ overflow: "visible", width: '100%', borderRadius: '16px' }}>
                                <SoftBox mx={2} mt={1} mb={1}>
                                    <SoftBox display='flex' flexDirection='row' justifyContent='space-between'>
                                        <Grid container>
                                            <Grid item xxs={8}>
                                                <SoftBox height="100%" display="flex" flexDirection="column" justifyContent="center">
                                                    <SoftTypography variant="h5" fontWeight="bold">All Assignments</SoftTypography>
                                                    {deviceLayout != 'mobile' && (
                                                        <SoftTypography variant="body3">Across Your Organisation</SoftTypography>
                                                    )}
                                                </SoftBox>
                                            </Grid>
                                        </Grid>
                                    </SoftBox>
                                </SoftBox>
                            </Card>
                        </SoftBox>
                        <Box display="flex" flex={1} flexDirection={{ xxs: "column", md: "row" }} px={1} sx={{ height: `calc(100% - 90px)` }}>
                            <Box flex={{ xxs: 12, md: 6 }} pb={{ xxs: 1, md: 0 }} pr={{ xxs: 0, md: 0.5 }} height="100%">
                                {inspectionTimeline}
                            </Box>
                            <Box flex={{ xxs: 12, md: 6 }} pl={{ xxs: 0, md: 0.5 }}>
                                <SoftBox height={"100%"}>
                                    <InspectionPreviewCard {...{ selectedInspection, setSelectedInspection, user, deviceLayout }} />
                                </SoftBox>

                            </Box>
                        </Box>
                    </SoftBox>
                )}
            </SoftBox>
        ), deviceLayout
    );
}

AllAssignmentsView.propTypes = {
    map: PropTypes.object,
    user: PropTypes.object
}

export default AllAssignmentsView;